/**
 * Map remote or legacy image URLs to local WebP assets in /assets or /images.
 */
const WEBP_OVERRIDES = {
  // KBeacon variants - exact filenames
  '1-White-KBeacon.png': '/assets/products/kbeacon/1-White-KBeacon.webp',
  '1-White-KBeacon.jpg': '/assets/products/kbeacon/1-White-KBeacon.webp',
  '1-Black-KBeacon.png': '/assets/products/kbeacon/1-Black-KBeacon.webp',
  '1-Black-KBeacon.jpg': '/assets/products/kbeacon/1-Black-KBeacon.webp',
  '2-White-KBeacon.png': '/assets/products/kbeacon/2-White-KBeacon.webp',
  '2-White-KBeacon.jpg': '/assets/products/kbeacon/2-White-KBeacon.webp',
  '2-Black-KBeacon.png': '/assets/products/kbeacon/2-Black-KBeacon.webp',
  '2-Black-KBeacon.jpg': '/assets/products/kbeacon/2-Black-KBeacon.webp',
  '3-Black-KBeacon.png': '/assets/products/kbeacon/3-Black-KBeacon.webp',
  '3-Black-KBeacon.jpg': '/assets/products/kbeacon/3-Black-KBeacon.webp',
  '4-Black-KBeacon.png': '/assets/products/kbeacon/4-Black-KBeacon.webp',
  '4-Black-KBeacon.jpg': '/assets/products/kbeacon/4-Black-KBeacon.webp',
  '5-Black-KBeacon.png': '/assets/products/kbeacon/5-Black-KBeacon.webp',
  '5-Black-KBeacon.jpg': '/assets/products/kbeacon/5-Black-KBeacon.webp',
  '6-Black-KBeacon.png': '/assets/products/kbeacon/6-Black-KBeacon.webp',
  '6-Black-KBeacon.jpg': '/assets/products/kbeacon/6-Black-KBeacon.webp',
  
  // S6 sensors - exact filenames
  'S6.png': '/assets/products/s6/S6.webp',
  'S6.jpg': '/assets/products/s6/S6.webp',
  'S6-2.png': '/assets/products/s6/S6-2.webp',
  'S6-2.jpg': '/assets/products/s6/S6-2.webp',
  'S6-3.png': '/assets/products/s6/S6-3.webp',
  'S6-3.jpg': '/assets/products/s6/S6-3.webp',
  'S6-4.png': '/assets/products/s6/S6-4.webp',
  'S6-4.jpg': '/assets/products/s6/S6-4.webp',
  'S6-5.png': '/assets/products/s6/S6-5.webp',
  'S6-5.jpg': '/assets/products/s6/S6-5.webp',
  
  // S6T2 sensors - exact filenames
  'S6T2.png': '/assets/products/s6t2/S6T2.webp',
  'S6T2-2.png': '/assets/products/s6t2/S6T2-2.webp',
  
  // S6T3 sensors - exact filenames
  'S6T3.png': '/assets/products/s6t3/S6T3.webp',
  'S6T3-2.png': '/assets/products/s6t3/S6T3-2.webp',
  
  // Gateway variants - exact filenames
  'gateway-1.png': '/assets/products/gateway/gateway-1.webp',
  'gateway-2.png': '/assets/products/gateway/gateway-2.webp',
  'gateway-3.png': '/assets/products/gateway/gateway-3.webp',
  'gateway-4.png': '/assets/products/gateway/gateway-4.webp',
  
  // ELA sensor - exact filename
  'ELA_Blue_PUCK_T_EN12830.png': '/assets/ELA_Blue_PUCK_T_EN12830.webp',
  
  // BLogm sensors - exact filenames
  'blogm.png': '/assets/products/blogm/blogm.webp',
  'blogm2.png': '/assets/products/blogm/blogm2.webp',
  
  // Premium bundle - exact filename
  'premium-bundle-removebg-preview.png': '/assets/premium-bundle-removebg-preview.webp',
  
  // Gateway hash filename
  'ca3fa4424957a6232681d8abcf39a7c3.png': '/assets/ca3fa4424957a6232681d8abcf39a7c3.webp',
};

export function toWebpImageUrl(url) {
  if (!url || typeof url !== 'string') {
    return url;
  }

  if (url.endsWith('.webp') || url.endsWith('.svg')) {
    return url;
  }

  const filename = url.split('/').pop()?.split('?')[0];
  if (filename && WEBP_OVERRIDES[filename]) {
    return WEBP_OVERRIDES[filename];
  }

  // No pattern matching - only exact filename matches
  return url;
}
